import Box from '@mui/material/Box';
import { alpha } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import React from 'react';

import { GOOGLE_MAP_URL } from '../../../../../configs/url-constants';

/** Free Google Maps iframe embed -- no API key required. */
export const MapSquare: React.FC<{ address: string }> = ({ address }) => {
  const mapQuery = encodeURIComponent(address);
  const mapPath = `${GOOGLE_MAP_URL}?q=${mapQuery}`;
  const embedSrc = `${mapPath}&output=embed`;

  return (
    <Box
      component="a"
      href={mapPath}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={`Open map of ${address} in Google Maps`}
      sx={{
        display: 'block',
        textDecoration: 'none',
        borderRadius: '6px',
        overflow: 'hidden',
        aspectRatio: '16/10',
        width: '100%',
        position: 'relative',
        bgcolor: 'grey.200',
        '&:focus-visible': { outline: '2px solid', outlineColor: 'primary.main' },
      }}
    >
      <Box
        component="iframe"
        src={embedSrc}
        title={`Map of ${address}`}
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        sx={{
          width: '100%',
          height: '100%',
          border: 0,
          display: 'block',
          pointerEvents: 'none',
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          bottom: 6,
          right: 6,
          bgcolor: (theme) => alpha(theme.palette.background.paper, 0.9),
          borderRadius: '4px',
          px: 1,
          py: 0.25,
          '&:hover': { bgcolor: 'common.white' },
        }}
      >
        <Typography sx={{ fontSize: '9px', fontWeight: 600, color: 'primary.main' }}>
          Open in Maps
        </Typography>
      </Box>
    </Box>
  );
};
